const faqItems = [
  {
    question: 'What IT services does BitNinja Technologies offer?',
    answer: 'BitNinja Technologies offers a full spectrum of IT services including web development, mobile app development, UI/UX design, cloud solutions, digital marketing, and IT consulting. We serve startups, enterprises, and growing businesses worldwide from our offices in Surat, India and California, US.',
  },
  {
    question: 'How long does it take to build a custom website with BitNinja?',
    answer: 'Typical web development projects at BitNinja take 4 to 12 weeks depending on complexity and scope. A standard 5-page business website can be delivered in 3-4 weeks, while a complex web application with custom features may take 8-12 weeks. We provide a clear timeline during the discovery phase.',
  },
  {
    question: 'Do you provide ongoing maintenance and support after project delivery?',
    answer: 'Yes, absolutely. BitNinja offers flexible post-launch support plans including monthly maintenance, performance monitoring, security updates, content updates, and technical support. Our support response time averages 30 minutes during business hours.',
  },
  {
    question: 'What technologies does BitNinja specialize in?',
    answer: 'We specialize in modern technologies including React, Next.js, TypeScript, Node.js, Python, PostgreSQL, MongoDB, AWS, Docker, Kubernetes, React Native, Flutter, and more. Our team stays current with the latest industry standards to deliver future-proof, scalable solutions.',
  },
  {
    question: 'Where is BitNinja Technologies located and do you serve international clients?',
    answer: 'BitNinja Technologies is headquartered in Surat, Gujarat, India with a US office in San Francisco, California. We serve clients globally across North America, Europe, Asia-Pacific, and the Middle East. Remote collaboration is built into our workflow, making distance a non-issue.',
  },
  {
    question: 'How much does a typical IT project with BitNinja cost?',
    answer: 'Our projects range from $999 for a starter business website to $4,999+ for enterprise-grade web applications. Mobile app development typically starts at $2,499. Every project is scoped individually — we provide a detailed, no-obligation quote after understanding your specific requirements during a free consultation.',
  },
  {
    question: 'What makes BitNinja different from other IT companies?',
    answer: 'BitNinja combines deep technical expertise with a design-first approach. We are not just coders — we are strategic partners who obsess over business outcomes. With 20+ years of collective team experience, 50+ projects delivered, and a 98% client satisfaction rate, we consistently deliver solutions that drive measurable business growth.',
  },
  {
    question: 'Do you sign NDAs and protect intellectual property?',
    answer: 'Yes, BitNinja Technologies signs Non-Disclosure Agreements (NDAs) as standard practice before discussing any sensitive project details. All client intellectual property remains 100% yours. We follow strict data protection protocols and can work within your existing compliance frameworks.',
  },
];

export { faqItems };

const FAQSection = () => {
  return (
    <section id="faq" className="relative w-full bg-background-100 border-t border-background-200 py-14 md:py-16">
      <div className="section-padding">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                <i className="ri-question-answer-line text-xs"></i>
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                10 / FAQ
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900">
              Frequently Asked{' '}
              <span className="block text-primary-500">Questions.</span>
            </h2>
            <p className="mt-4 text-foreground-600 max-w-2xl mx-auto text-[15px] leading-relaxed">
              Everything you need to know about working with BitNinja Technologies.
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <details
                key={index}
                className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden transition-all duration-300"
              >
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                  <h3 className="font-display text-base md:text-lg font-bold text-foreground-900 pr-4 group-open:text-primary-500 transition-colors">
                    {item.question}
                  </h3>
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 border border-background-200 flex-shrink-0 group-open:bg-foreground-900 group-open:border-foreground-900 transition-all">
                    <i className="ri-add-line text-foreground-700 group-open:text-background-50 group-open:hidden"></i>
                    <i className="ri-subtract-line text-background-50 hidden group-open:block"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>

          <div className="text-center mt-10">
            <p className="text-foreground-500 text-sm mb-4">
              Still have questions? We are happy to help.
            </p>
            <a
              href="/#contact"
              className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Get in Touch
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;